// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLineCardExpandedStyles } from "@bg/Overrides/Widgets/Cart/CartLineCardExpanded";
import xScreen from "@bg/XDL/Utilities/xScreen";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// Move from widget file to extensions
cartLineCardExpandedStyles.container = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        padding: 11px 10px 20px 0;
        border-bottom: 1px solid ${getColor("common.ui2")};
        position: relative;
        @media print {
            width: 100%;
            display: block !important;
            border-bottom: 1px solid #b0b0b7;
            page-break-inside: avoid;
        }
        ${xScreen("lte", "sm")} {
            padding-bottom: 12px;
        }
    `,
};

cartLineCardExpandedStyles.leftSection = {
    css: css`
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-left: 10px;
        @media (max-width: 900px) {
            width: 100%;
            padding-left: 0;
            margin-top: 15px;
        }
        @media (max-width: 580px) {
            padding: 0;
        }

        @media print {
            display: block;
            padding: 0;
            width: 100%;
        }
    `,
};
